import {type ComponentType} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ComponentType<{size?: string; fill?: string; className?: string}>;
    text: string;
}

export const HomeMatchBasicPreferencesFlowPreferenceRow = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div className={preferenceRowStyle}>
            <div className={iconWrapperStyle}>
                <Icon size="2.4" fill="var(--colors-gray-800)" />
            </div>
            <Text variant="body_copy_1">{props.text}</Text>
        </div>
    );
};

const preferenceRowStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5
});

const iconWrapperStyle = css({
    width: "2.4rem",
    height: "2.4rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
import {type ComponentType} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    icon: ComponentType<{size?: string; fill?: string; className?: string}>;
    text: string;
}

export const HomeMatchBasicPreferencesFlowPreferenceRow = (props: IProps) => {
    const Icon = props.icon;

    return (
        <div className={preferenceRowStyle}>
            <div className={iconWrapperStyle}>
                <Icon size="2.4" fill="var(--colors-gray-800)" />
            </div>
            <Text variant="body_copy_1">{props.text}</Text>
        </div>
    );
};

const preferenceRowStyle = css({
    display: "flex",
    alignItems: "center",
    gap: 0.5
});

const iconWrapperStyle = css({
    width: "2.4rem",
    height: "2.4rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
